import styled, { css } from 'styled-components';

// @ts-nocheck
var ExpandableTagGroup = styled.div.withConfig({
  displayName: "ExpandableTagGroupstyle__ExpandableTagGroup",
  componentId: "sc-1ueombq-0"
})([""]);
var TagList = styled.ul.withConfig({
  displayName: "ExpandableTagGroupstyle__TagList",
  componentId: "sc-1ueombq-1"
})(["display:flex;flex-wrap:wrap;gap:8px;.tag-list__toggleable-item{", "}"], function (_ref) {
  var $isExpanded = _ref.$isExpanded;
  return !$isExpanded && css(["display:none;"]);
});
var TagListItem = styled.li.withConfig({
  displayName: "ExpandableTagGroupstyle__TagListItem",
  componentId: "sc-1ueombq-2"
})(["display:flex;align-items:center;", ""], function (_ref2) {
  var $displayLast = _ref2.$displayLast;
  return $displayLast && css(["order:1;"]);
});

export { ExpandableTagGroup, TagList, TagListItem };
//# sourceMappingURL=ExpandableTagGroup.style.js.map
